import './elsieAiSummary.scss';
import { Button } from '@progress/kendo-react-buttons';
import { useProjectPermissions } from '../../hooks/permissions';
import { useNavigateWithProjectId } from '../../hooks/route';
import { KWELLO_ICON, KwelloSvgIcon } from 'common/components/icon/KwelloSvgIcon';
import { ANALYZE_ROUTES } from 'routes/routes.const';

interface ElsieAISummaryFooterProps {
  onClose: () => void;
  onDeleteAll: () => void;
}

export function ElsieAISummaryFooter({
  onClose,
  onDeleteAll,
}: Readonly<ElsieAISummaryFooterProps>) {
  const { hasPermission } = useProjectPermissions();
  const navigate = useNavigateWithProjectId();

  const gotoElsieAI = () => {
    onClose();
    onDeleteAll();
    navigate(ANALYZE_ROUTES.elsieai);
  };

  return (
    <div className="elsie-summary-flyout-footer">
      <div className="footer-buttons">
        <Button fillMode="outline" themeColor="light" onClick={onClose}>
          Close
        </Button>
        {hasPermission(ANALYZE_ROUTES.elsieai) && (
          <Button fillMode="solid" themeColor="primary" onClick={gotoElsieAI} size="large">
            <KwelloSvgIcon icon={KWELLO_ICON.NAVIGATE_ARROW} />
            Go to ElsieAI
          </Button>
        )}
      </div>
    </div>
  );
}
